// extracted by mini-css-extract-plugin
export default {"topic":"create-event_topic__WcP0h","keyWords":"create-event_keyWords__reFoc"};